<template>
  <ButtonSquareHoverChecklist
    :title="$t('general__view__map-services')"
    :imgSource="iconMaps"
    size="large"
    :hoverButtons="hoverButtons"
    :activeState="activeState"
    @clicked="toggleButton"
    @hovered="onHover"
    @onChecklistToggle="updateFilteredWmsLayers"
  />
</template>

<script lang="ts" setup>
import ButtonSquareHoverChecklist from '@/components/general/buttons/ButtonSquareHoverChecklist.vue'
import { useGeneralStore } from '@/pinia'
import { computed, ref } from 'vue'
import iconMaps from '@/assets/icon-maps.svg'

const props = defineProps<{
  wmsHoverButtons: any[]
}>()
const emits = defineEmits<{
  (e: 'MapWmsButtonHovered'): void
}>()
const piniaStore = useGeneralStore()

const buttonActive = ref(false)
const activeState = computed(() => {
  return buttonActive.value ? 'active' : 'inactive'
})

const hoverButtons = computed(() => {
  const layers: any[] = []
  props.wmsHoverButtons.forEach((wms) => {
    layers.push({
      ...wms,
      disabled: false,
      emit: wms.id,
      title: wms.name,
      types: [{}]
    })
  })
  return layers
})

function onHover() {
  emits('MapWmsButtonHovered')
}
function toggleButton() {
  buttonActive.value = !buttonActive.value
}

function updateFilteredWmsLayers(id: string | number) {
  const wmsLayers = piniaStore.filteredWmsLayers
  const index = wmsLayers.findIndex((layer) => layer.id === id)
  if (index === -1) return
  wmsLayers[index].visible = !wmsLayers[index].visible
  piniaStore.setFilteredWmsLayers(wmsLayers)
}
</script>
